import React, { useEffect, useState } from 'react';

/* 🎶 Our soundtrack — the songs that sound like us.
   Plays the official releases via privacy-enhanced YouTube embeds
   (youtube-nocookie, loaded only when a song is tapped — nothing is
   bundled or re-hosted, so the artists get every play). The ambient
   instrumental pauses while a song plays; onOpen/onClose handle that. */

const SONGS = [
  {
    id: 'bairan',
    yt: 'oafxkMv4xnc',
    title: 'Bairan',
    artist: 'Banjaare',
    note: 'kind of our song. okay — exactly our song.',
    ours: true,
  },
  {
    id: 'dooron',
    yt: 'LV_wiOhO40Q',
    title: 'Dooron Dooron',
    artist: 'Paresh Pahuja',
    note: 'for every minute we weren’t in the same city',
  },
  {
    id: 'until',
    yt: 'GxldQ9eX2wo',
    title: 'Until I Found You',
    artist: 'Stephen Sanchez',
    note: 'self-explanatory, really 🫶',
  },
  {
    id: 'moon',
    yt: 'JYuyWrkwpok',
    title: 'Fly Me to the Moon',
    artist: 'Frank Sinatra',
    note: 'old school, like my manners on date one',
  },
  {
    id: 'found-you',
    yt: 'tNFj9IdpMQM',
    title: 'Baby Now That I’ve Found You',
    artist: 'The Foundations',
    note: 'the Off Campus anthem — Garrett knew. 🏒',
  },
  {
    id: 'girls',
    yt: 'p9wsEOVK4cw',
    title: 'GIRLS',
    artist: 'The Kid LAROI',
    note: 'episode 4 energy 😏',
  },
];

export default function Soundtrack({ onOpen, onClose }) {
  const [playing, setPlaying] = useState(null); // song id

  const open = (id) => {
    setPlaying(id);
    if (onOpen) onOpen();
  };
  const close = () => {
    setPlaying(null);
    if (onClose) onClose();
  };

  useEffect(() => {
    if (!playing) return undefined;
    const onKey = (e) => {
      if (e.key === 'Escape') close();
    };
    window.addEventListener('keydown', onKey);
    return () => window.removeEventListener('keydown', onKey);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [playing]);

  const song = SONGS.find((s) => s.id === playing);

  return (
    <div className="aj-st">
      <h3 className="aj-letters-title">our soundtrack 🎶</h3>
      <p className="anusha-sub">the songs that sound like us — tap one, right here in our little world.</p>

      <div className="aj-st-list">
        {SONGS.map((s) => (
          <button type="button" key={s.id} className="aj-st-row" onClick={() => open(s.id)}>
            <span className="aj-st-play" aria-hidden="true">▶</span>
            <span className="aj-st-info">
              <span className="aj-st-title">
                {s.title}
                {s.ours && <span className="aj-st-ours">OUR SONG 💛</span>}
              </span>
              <span className="aj-st-artist">{s.artist}</span>
              <span className="aj-st-note">{s.note}</span>
            </span>
          </button>
        ))}
      </div>

      {song && (
        <div className="aj-letter-overlay" onClick={close}>
          <div className="aj-st-player" onClick={(e) => e.stopPropagation()}>
            <button type="button" className="aj-ss-close aj-st-close" onClick={close} aria-label="close player">
              ×
            </button>
            <div className="aj-st-player-head">
              <div className="aj-st-player-title">{song.title}</div>
              <div className="aj-st-player-artist">{song.artist}</div>
            </div>
            <div className="aj-st-frame">
              <iframe
                src={`https://www.youtube-nocookie.com/embed/${song.yt}?autoplay=1&rel=0&modestbranding=1&playsinline=1`}
                title={`${song.title} — ${song.artist}`}
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                allowFullScreen
              />
            </div>
            <a
              className="aj-st-yt"
              href={`https://www.youtube.com/watch?v=${song.yt}`}
              target="_blank"
              rel="noreferrer"
            >
              open on YouTube ↗
            </a>
          </div>
        </div>
      )}
    </div>
  );
}
